<p-table styleClass="alpha-border-1 surface-border" [value]="variables" [scrollable]="true" scrollHeight="flex">
    <!-- table header start -->
    <ng-template pTemplate="header">
        <tr class="text-normal text-lg">
            <th class="col-2">
                <div class="relative inline pr-4">
                    {{ 'default-cm-serial-number' | translate: 'Sl No' }}
                </div>
            </th>
            <th class="col-3">
                <div class="relative inline pr-4">
                    {{ 'default-cm-key' | translate: 'Key' }}
                </div>
            </th>
            <th class="col-5">
                <div class="relative inline pr-4">
                    {{ 'default-cm-value' | translate: 'Value' }}
                </div>
            </th>
        </tr>
    </ng-template>
    <!-- table header end -->

    <!-- table body start -->
    <ng-template pTemplate="body" let-variable let-i="rowIndex">
        <tr class="text-normal text-md">
            <td class="col-2">
                <span class="block overflow-hidden text-overflow-ellipsis white-space-nowrap">{{ i + 1 }}</span>
            </td>
            <td class="col-3">
                <span
                    class="block overflow-hidden text-overflow-ellipsis white-space-nowrap max-w-20rem"
                    pTooltip="{{ variable.name }}"
                    tooltipPosition="bottom"
                    >{{ variable.name }}</span
                >
            </td>
            <td class="col-5">
                <span
                    class="block overflow-hidden text-overflow-ellipsis white-space-nowrap max-w-20rem"
                    pTooltip="{{ variable.value }}"
                    tooltipPosition="bottom"
                    >{{ variable.value }}</span
                >
            </td>
        </tr>
    </ng-template>
    <!-- table body end -->
</p-table>
